import React from "react";
import styles from "./SubBanner.module.scss";

const SubBanner = ({ title, hasMarginBottom }) => {
    return (
        <div
            className={styles.banner}
            style={{ marginBottom: hasMarginBottom ? hasMarginBottom : undefined }}
        >
            <div className={styles.banner__inner}></div>
            <div className={styles.banner__bg}>
                <picture className={styles.banner__imgBox}>
                    <source srcSet="/assets/images/sub_topBg.webp" type="image/webp" />
                    <img
                        className={styles.banner__imgBox_img}
                        src="/assets/images/sub_topBg.jpg"
                        alt="intro_img"
                        width={"100%"}
                        height={"100%"}
                    />
                </picture>
            </div>
            <h1 className={styles.banner__title}>{title}</h1>
        </div>
    );
};

export default SubBanner;
